import { UnitPrice } from '@ravago/shared/page-data/models/elements';
import { TableCell } from '@ravago/shared/radiance/components/table/components/TableCell/TableCell';
import { TableRow } from '@ravago/shared/radiance/components/table/components/TableRow/TableRow';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useFormatter, useTranslations } from '@ravago/shared/translations/client';

interface Props {
   unitPrice: UnitPrice;
   isUnitPriceFixed: boolean;
   canViewPrices: boolean;
}

const DefaultContent = ({ unitPrice, isUnitPriceFixed }: { unitPrice: UnitPrice; isUnitPriceFixed: boolean }) => {
   const translate = useTranslations();
   const format = useFormatter();

   return <Typography variant="small">{isUnitPriceFixed ? format.unitPrice(unitPrice) : translate('my-orders.unit-price-tbc')}</Typography>;
};

const RestrictedContent = () => {
   const translate = useTranslations();
   return <Typography color="subtle">{translate('permissions.access-to-price-restricted-message')}</Typography>;
};

export const OrderPriceInfoRow = ({ unitPrice, isUnitPriceFixed, canViewPrices }: Props) => {
   const translate = useTranslations();

   return (
      <TableRow>
         <TableCell>
            <Typography component="b" variant="small-highlight" color="primary">
               {translate('my-orders.unit-price')}
            </Typography>
         </TableCell>
         <TableCell>{canViewPrices ? <DefaultContent unitPrice={unitPrice} isUnitPriceFixed={isUnitPriceFixed} /> : <RestrictedContent />}</TableCell>
      </TableRow>
   );
};
